(() => {
  const privacyPolicyUrl = document.currentScript.dataset.privacyPolicyUrl;

  if (!privacyPolicyUrl) return;

  const updatePolicyLink = () => {
    const link = document.getElementById('shopify-pc__banner__body-policy-link');

    if (link && link.getAttribute('href') !== privacyPolicyUrl) {
      link.setAttribute('href', privacyPolicyUrl);
    }
  };

  // Shopify inserts the banner asynchronously and may render it again.
  new MutationObserver(updatePolicyLink).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['href'],
  });

  updatePolicyLink();
})();
